"use client";

import Image from "next/image";
import Link from "next/link";

interface TeamMemberCardProps {
  name: string;
  position: string;
  office: string;
  imageUrl: string;
  profileUrl: string;
}

export default function TeamMemberCard({name, position, office, imageUrl, profileUrl}: TeamMemberCardProps) {

  return (
    <Link href={profileUrl} className="group relative block w-[190px] md:w-[300px] text-center">

      {/* Image */}
      <div className="relative w-full h-[200px] md:h-[350px] overflow-hidden bg-gray-100">
        <Image src={imageUrl} alt={name} quality={90} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 600px" 
        fill className="object-cover transition duration-500 group-hover:scale-105"/>
      </div>

      {/* Tooltip */}
      <div className="absolute flex flex-col items-center left-1/2 bottom-[-20px] -translate-x-1/2 bg-white shadow-lg rounded-md px-4
        py-4 w-[88%] opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-300 
        pointer-events-none before:content-[''] before:absolute before:top-[-12px] before:left-1/2 before:-translate-x-1/2 
        before:border-l-[12px] before:border-r-[12px] before:border-b-[12px] before:border-l-transparent before:border-r-transparent
        before:border-b-white"
      >
        <h3 className="text-[15px] font-semibold text-primary">{name}</h3>
        <div className="flex flex-col md:flex-row items-center gap-1">
          <p className="text-[14px] text-gray-800 leading-snug">{position}</p>
          <span className="
  mx-1
  md:border-l-2 md:h-[14px] md:inline-block md:align-middle
  border-t-2 w-full md:w-auto
  border-secondary
  block
"></span>

          <p className="text-[14px] text-gray-800 leading-snug">{office}</p>
        </div>
      </div>

    </Link>
  );
}
